/**
 * Oznámení — widget-first stránka: historie jako karta (zvoneček = rychlý
 * pomíjivý povrch, tady je dohledatelnost). Panel: registry.notifications.
 */
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('notifications');
const DEF_OK = DEF;

export default function NotificationsPage() {
  return <ModuleWorkspace def={DEF_OK} hideHeader defaultTab='history' />;
}
